import * as types from "./types"

export default {
  [types.USER_REG_FORM]: {},
  [types.INDEX_DATA_KNOWLAGE]: [],
  [types.CURRENT_AUDIO_URL]: '',
}



// WEBPACK FOOTER //
// ./src/store/state.js